var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailabilityInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5845 2.65723H4.91853C3.99358 2.65723 3.25195 3.40723 3.25195 4.32389V15.9906C3.25195 16.9072 3.99358 17.6572 4.91853 17.6572H16.5845C17.5012 17.6572 18.2511 16.9072 18.2511 15.9906V4.32389C18.2511 3.40723 17.5012 2.65723 16.5845 2.65723ZM14.918 10.9906H11.5848V14.3239H9.91825V10.9906H6.5851V9.32389H9.91825V5.99056H11.5848V9.32389H14.918V10.9906Z",
    fill: "#DBDDE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailabilityInactive);
export default __webpack_public_path__ + "static/media/availability_inactive.2453696ae632708c5e219b7e32750540.svg";
export { ForwardRef as ReactComponent };